import { newSpinner } from 'trunks/vue/admin/components/spinner.js';

export default Vue.extend({
  data() {
    return {
      requestError: false,
      requestSuccess: false,
      file: null,
      uploadRequest: false,
      spinner: null,
    };
  },

  computed: {
    headersData() {
      return {
        X_CSRF_Token: document.head.querySelector('meta[name=csrf-token]').content,
      };
    },

    buttonDisabled() {
      return !this.file || !!(this.file && this.requestError);
    },
  },

  watch: {
    requestError() {
      if (this.requestError) {
        setTimeout(() => {
          this.uploadRequest = false;
        }, 3000);
      }
    },
  },

  created() {
    this._setFile();
  },

  methods: {
    removeFileFunc() {
      this.$refs.uploadInput.value = '';
      this.filesChangedFunc();
    },

    closeUploadMaskFunc() {
      this.uploadRequest = false;
    },

    cancel() {
      this.$refs.modal.close();
    },

    open() {
      this.$refs.modal.open();
    },

    filesChangedFunc() {
      this._setFile();
      this.requestError = false;
    },

    ensureClick(type) {
      if (this.requestSuccess) {
        this.cancel();
      } else {
        this.importFile(type);
      }
    },

    importFile(type) {
      const uploadFile = new Skylark.Libs.Storage.Attachment(this.file);
      this.uploadRequest = true;
      this.spinner = newSpinner({
        size: 'small',
      });
      uploadFile.upload({
        success: () => {
          this.doRequest(uploadFile.id, type);
        },
        error: () => {
          this.requestError = true;
          this.requestSuccess = false;
        },
        complete: () => {
          this.spinner.close();
        },
      });
    },

    doRequest(id, type) {
      const data = type ? { type, attachment_id: id } : { attachment_id: id };

      Skylark.Libs.Ajax.post(this.importRecordsUrl, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data,
        success: () => {
          this.requestSuccess = true;
          this.requestError = false;
        },
        error(xhr, status, error) {
          const text = error.error ? error.error : '导入成员失败';
          Skylark.Bridge.newAlertify(text, {
            type: 'error',
          });
        },
      });
    },

    _setFile() {
      this.file = this.$refs.uploadInput && this.$refs.uploadInput.files[0];
    },
  },
});
